import { makeStyles } from 'tss-react/mui';

const name = 'SelectMenuItem';

export const useSelectMenuItemStyles = makeStyles({ name })(theme => ({
  root: {
    width: '100%',
    padding: theme.spacing(2),

    borderRadius: theme.shape.borderRadiusMd,
  },
}));
